import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { STORELOCATORCOMPONENT } from '../components/storelocator.component';
import { LOCATIONCOMPONENT } from '../components/location.component';
import { ORDERATHOME } from '../components/orderathome.component';
import { HEADLINE } from '../components/headline.component';
import { GOOGLEMAPSERVICE } from './google.map.service';
import { SEARCHSERVICE } from './search.service';
import { ROUTE } from './route.directions.service';
import { MARKER } from './google.marker.service';
import { IMAGEVIEW } from './imageview.service';
import { URLSERVICE } from './url.service';
import { FILTER } from './filter.service';
import { HELPER } from './helper.service';
import { XTCI } from './xtci.service';

export class MultipleLocationsService {
  /**
   * Propertys
   */
  currentLocationRequest: boolean;
  productImagesContainer: Element;
  sidebarScrollHeight: string;
  locationInfo: HTMLElement;
  locationDetails: HTMLElement;
  sidebarHeader: HTMLElement;
  sidebarBody: HTMLElement;
  backButton: HTMLElement;
  mapContent: HTMLElement;
  sidebar: HTMLElement;
  search: HTMLElement;
  map: HTMLElement;

  xtciRequest() {
    let responseXML: object;
    const location_xml = XTCI.createXML(
      'locationlist_request',
      STORELOCATORCOMPONENT.getRequestData('locationlist_request'),
    ) as Document;

    XTCI.executeRequest(
      location_xml,
      (response_xml) => {
        responseXML = response_xml;
        if (!this.map) {
          GOOGLEMAPSERVICE.initMap();
        }

        this.getPlaceDetails(responseXML);
      },
      STORELOCATORCOMPONENT.displayNoticeOverlay,
      TextResources.resources['error'].location,
    );

    STORELOCATORCOMPONENT.requestDataLocation = {};
    return responseXML;
  }

  getPlaceDetails(responseXML) {
    if (!this.sidebar) {
      this.mapContent = STORELOCATORCOMPONENT.mapContentHtmlElement;
      this.sidebar = STORELOCATORCOMPONENT.sidebarHtmlElement;
      this.map = STORELOCATORCOMPONENT.mapHtmlElement;
      this.getLocationsSidebar();
    }
    const currentLocations = LOCATIONCOMPONENT.placeLocations(responseXML);
    LOCATIONCOMPONENT.currentLocations = currentLocations;
    this.handleLocationsSidebar();
    if (ConfigData.data['headline']) {
      let cityName: string;
      if (!ConfigData.data['currentCity']) {
        const locationNode = this.getLocationNode(responseXML);
        cityName = this.extractCity(locationNode);
      } else {
        cityName = STORELOCATORCOMPONENT.currentCity;
      }

      HEADLINE.createHeadline(cityName, ConfigData.data['headline'], 'multi');
    }
    MARKER.handleMarkers(currentLocations);
  }

  getLocationsSidebar() {
    this.createSidebarBounds();
  }

  setSidebarBodyMaxHeight(height: number) {
    const deviceInfo = ConfigData.data['deviceInfo'].os();

    if (deviceInfo === 'iOS' || deviceInfo === 'AndroidOS') {
      return;
    } else {
      this.sidebarBody.style.maxHeight = `${height}px`;
    }
  }

  createSidebarBounds() {
    const hasSidebarHeader = document.querySelector<HTMLElement>('cwc-sidebar-header');
    const hasSidebarBody = document.querySelector<HTMLElement>('cwc-sidebar-body');

    this.sidebarHeader = hasSidebarHeader ? hasSidebarHeader : document.createElement('cwc-sidebar-header');
    this.sidebarBody = hasSidebarBody ? hasSidebarBody : document.createElement('cwc-sidebar-body');

    this.sidebar.appendChild(this.sidebarHeader);
    this.sidebar.appendChild(this.sidebarBody);

    this.sidebar.className = 'sidebar-on';
    this.map.className = 'sidebar-on';
  }

  handleLocationsSidebar() {
    const searchElement = SEARCHSERVICE.initSearchElement();
    this.search = searchElement;
    searchElement.className = 'shadow';
    this.sidebarHeader.prepend(searchElement);

    if (ConfigData.data['currentFilter'] === 'none') {
      this.sidebarBody.style.marginTop = '0';
    } else {
      FILTER.createLocationsFilter();
    }

    const sidebarChildNodes = this.sidebarBody.querySelectorAll('cwc-location');
    sidebarChildNodes.forEach((element) => {
      this.handleShowDetails(element);
      this.handleAccordion(element);
    });
    // const lastLocation = this.sidebarBody.lastChild as HTMLElement;
    // lastLocation.classList.add('last');

    if (this.sidebarScrollHeight === undefined) {
      this.sidebarScrollHeight = `${this.sidebarBody.offsetHeight - this.sidebarHeader.offsetHeight}`;
    }
    this.setSidebarBodyMaxHeight(Number(this.sidebarScrollHeight));
  }

  // handle accordion
  handleAccordion(element) {
    const accordion = element.querySelectorAll('.accordion');

    for (let i = 0; i < accordion.length; i++) {
      accordion[i].addEventListener('click', () => {
        const arrowIcon = accordion[i].querySelector('span.right');
        const panel = accordion[i].nextElementSibling;
        let sidebarBodyHeight: string;

        accordion[i].classList.toggle('active');

        if (panel.style.maxHeight) {
          if (arrowIcon) {
            HELPER.changeClass(arrowIcon, 'icon-arrow-up', 'icon-arrow-down');
          }
          panel.style.maxHeight = null;
          sidebarBodyHeight = this.sidebarScrollHeight;
        } else {
          if (arrowIcon) {
            HELPER.changeClass(arrowIcon, 'icon-arrow-down', 'icon-arrow-up');
          }
          panel.style.maxHeight = `${panel.scrollHeight}px`;
          sidebarBodyHeight = `${Number(this.sidebarScrollHeight) - panel.scrollHeight}`;
        }

        if (accordion[i].parentElement.nodeName === 'CWC-FILTER') {
          this.setSidebarBodyMaxHeight(Number(sidebarBodyHeight));
        }
      });
    }
  }

  handleShowDetails(element) {
    const locationInfo = element.querySelector('cwc-location-info');
    const locationDetails = element.querySelector('cwc-location-details');
    const detailsInfoButton = element.querySelector('cwc-location-info .info-content');

    if (ConfigData.data['urlLandingPage'] || ConfigData.data['receiveParameters']) {
      detailsInfoButton.addEventListener('click', () => {
        window.location.href = URLSERVICE.getlandingPageURL() + '?locid=' + element.id;
      });
    } else {
      detailsInfoButton.addEventListener('click', () => {
        ORDERATHOME.createOrderAtHomeButton(element);
        locationInfo.classList.add('hide');
        locationDetails.classList.add('show');
        this.disableLocations();
        this.showLocationDetails(element);
        ROUTE.handleButtonItinerary(element);
        ROUTE.createRouteCalculation();
      });
    }
    this.locationDetails = locationDetails;
    this.locationInfo = locationInfo;
  }

  disableLocations() {
    const sidebarChildNodes = this.sidebarBody.querySelectorAll('cwc-location');
    sidebarChildNodes.forEach((element: Element) => {
      element.classList.add('hide');
    });
  }

  showLocationDetails(element) {
    const hasBackButton = this.sidebarHeader.querySelector('button.location-back') as HTMLButtonElement;
    const backButton = hasBackButton
      ? hasBackButton
      : STORELOCATORCOMPONENT.createBackButton(TextResources.resources['location'].control.back_results);
    this.backButton = backButton;
    backButton.addEventListener('click', () => {
      this.clickEventBackButton(element);
    });
    this.sidebarHeader.appendChild(backButton);
    this.search.classList.remove('shadow');
    if (ConfigData.data['currentFilter'] !== 'none') {
      FILTER.filterHTMLElement.classList.add('hide');
    }
    element.classList.remove('hide');
    MARKER.showLocationMarker(element.id);

    this.createProduktImages(element);

    this.setSidebarBodyMaxHeight(this.sidebarBody.parentElement.offsetHeight - this.sidebarHeader.offsetHeight);
  }

  createProduktImages(element) {
    const imageContent = element.querySelector('.img-items') as HTMLElement;
    const hasCwcProductImages = STORELOCATORCOMPONENT.mapContentHtmlElement.querySelector(
      'cwc-product-images',
    ) as HTMLElement;
    const productImagesContainer = hasCwcProductImages
      ? hasCwcProductImages
      : (document.createElement('cwc-product-images') as HTMLElement);

    if (!hasCwcProductImages) {
      // add product images container to cwc-map-content
      this.mapContent.appendChild(productImagesContainer);
      this.productImagesContainer = productImagesContainer;
    }

    IMAGEVIEW.createImageCarousel(imageContent, productImagesContainer, true);

    // handle product image button
    const imgButton = element.querySelector('.img-items-wrapper .button');
    const imgItems = element.querySelector('.img-items-slider .img-items');

    imgButton.addEventListener('click', function () {
      imgItems.classList.toggle('open');
      HELPER.changeNodeTextValue(
        this,
        TextResources.resources['location'].control.img_show_more,
        TextResources.resources['location'].control.img_show_less,
      );
    });
  }

  clickEventBackButton(element) {
    const locationInfo = element.querySelector('cwc-location-info');
    const locationDetails = element.querySelector('cwc-location-details');
    const locationItinerary = element.querySelector('cwc-location-itinerary');

    if (ConfigData.data['calculateRoute']) {
      HELPER.toggleTwoClasses(locationItinerary, 'show', 'hide');
      ROUTE.centerMapOnCurrentLocation();
    }

    this.search.classList.add('shadow');
    ROUTE.resetDirectionsMap();
    ROUTE.clearTravelMode();

    IMAGEVIEW.clearProductImagesContainer(this.productImagesContainer);

    this.backButton.remove();
    if (ConfigData.data['currentFilter'] !== 'none') {
      FILTER.filterHTMLElement.classList.remove('hide');
      FILTER.resetFilter();
    }

    locationDetails.removeAttribute('class');
    locationInfo.removeAttribute('class');

    for (let i = 0; i < this.sidebarBody.childNodes.length; i++) {
      const locationItem = this.sidebarBody.childNodes[i] as HTMLElement;
      locationItem.classList.remove('hide');
    }
    this.setSidebarBodyMaxHeight(this.sidebarBody.parentElement.offsetHeight - this.sidebarHeader.offsetHeight);

    MARKER.showAllMarkers(MARKER.latLngBounds);
    ConfigData.data['calculateRoute'] = false;
  }

  /**
   * Handles current location button click event.
   * When clicked, a new xtci query is started with current geocoordinates
   * and a search radius of 10km.
   */
  handleCurrentLocation() {
    this.currentLocationRequest = true;

    if (navigator.geolocation) {
      // Try HTML5 geolocation.
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const geoCoords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          SEARCHSERVICE.handleClear();
          STORELOCATORCOMPONENT.geoCoords = geoCoords;
          ROUTE.geoCoords = geoCoords;
          STORELOCATORCOMPONENT.sendLocationRequest(geoCoords);

          if (ConfigData.data['receiveParameters']) {
            URLSERVICE.updateParam(STORELOCATORCOMPONENT.currentCity);
          } else {
            URLSERVICE.deleteParams();
          }
        },
        () => {
          STORELOCATORCOMPONENT.displayNoticeOverlay(TextResources.resources['error'].geolocation_service);
        },
      );
    } else {
      // Browser doesn't support Geolocation
      STORELOCATORCOMPONENT.displayNoticeOverlay(TextResources.resources['error'].geolocation_support);
    }
  }

  getLocationNode(responseXML) {
    return responseXML.querySelector('locationlist > content > location');
  }

  extractCity(locationNode) {
    const city = HELPER.capitalizeFirstLetter(locationNode.querySelector('city').textContent);
    return city;
  }
}

export const MULTIPLELOCATIONSSERVICE = new MultipleLocationsService();
